export default "__VITE_ASSET__Cl97ZDMl__"